import { useEffect, useState } from 'react';

import { PERSISTENT_KEY_VIEW } from 'src/common/constants/persistentStorageKeys';
import { EView } from 'src/interfaces/View';

const LEGACY_USERS_VIEW_KEY = 'view.users';

function isEView(value: string | null): value is EView {
  return value === EView.grid || value === EView.table;
}

function readStoredView(): EView | null {
  const stored = localStorage.getItem(PERSISTENT_KEY_VIEW);
  if (isEView(stored)) {
    return stored;
  }

  const legacyUsersView = localStorage.getItem(LEGACY_USERS_VIEW_KEY);
  if (isEView(legacyUsersView)) {
    localStorage.setItem(PERSISTENT_KEY_VIEW, legacyUsersView);
    localStorage.removeItem(LEGACY_USERS_VIEW_KEY);
    return legacyUsersView;
  }

  return null;
}

export default function usePersistentView(defaultView = EView.grid) {
  const [view, setView] = useState<EView>(() => readStoredView() ?? defaultView);

  useEffect(() => {
    localStorage.setItem(PERSISTENT_KEY_VIEW, view);
  }, [view]);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === PERSISTENT_KEY_VIEW && event.newValue && isEView(event.newValue)) {
        setView(event.newValue);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return [view, setView] as const;
}
